import { atom } from 'jotai';
import { ReactNode } from 'react';

interface ConfirmModalProps {
    message: string;
    onConfirm: (rememberChoice?: boolean) => unknown;
    onCancel?: () => unknown;
    confirmText?: string;
    cancelText?: string;
    checkboxLabel?: string;
    checkboxDefaultChecked?: boolean;
    type: 'confirm';
}

interface InfoModalProps {
    message: string;
    buttonText?: string;
    onCancel?: () => unknown;
    type: 'info';
}

type ModalTypes = ConfirmModalProps | InfoModalProps;

type GlobalModalProps = ModalTypes & {
    title: ReactNode;
    backdropClassName?: string;
};

const globalModalAtom = atom<GlobalModalProps | null>(null);

export default globalModalAtom;
export type { ConfirmModalProps, InfoModalProps };
